function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34 34H37.334C39.826 34 41.072 34 42 33.464C42.608 33.1129 43.1129 32.608 43.464 32C44 31.072 44 29.826 44 27.334C44 22.348 44 19.856 42.928 18C42.2259 16.7839 41.2161 15.7741 40 15.072C38.144 14 35.652 14 30.666 14H17.334C12.348 14 9.856 14 8 15.072C6.78395 15.7741 5.77412 16.7839 5.072 18C4 19.856 4 22.348 4 27.334C4 29.826 4 31.072 4.536 32C4.88706 32.608 5.39197 33.1129 6 33.464C6.928 34 8.174 34 10.666 34H14M34 14V10C34 7.172 34 5.758 33.12 4.88C32.244 4 30.83 4 28 4H20C17.172 4 15.758 4 14.88 4.88C14 5.756 14 7.17 14 10V14",
  stroke: "#FF6600",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.75 20.5H37.5M34 28V38C34 40.828 34 42.242 33.12 43.12C32.242 44 30.828 44 28 44H20C17.172 44 15.758 44 14.88 43.12C14 42.244 14 40.83 14 38V28H34ZM38 20.5C38 20.6326 37.9473 20.7598 37.8536 20.8536C37.7598 20.9473 37.6326 21 37.5 21C37.3674 21 37.2402 20.9473 37.1464 20.8536C37.0527 20.7598 37 20.6326 37 20.5C37 20.3674 37.0527 20.2402 37.1464 20.1464C37.2402 20.0527 37.3674 20 37.5 20C37.6326 20 37.7598 20.0527 37.8536 20.1464C37.9473 20.2402 38 20.3674 38 20.5Z",
  stroke: "#FF6600",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPrinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.00e13b50.svg";
export { ForwardRef as ReactComponent };